// NATIVE 
import { useEffect, useState } from 'react';


// INSTALLED 
import { Avatar,  Button,  Card, Chip, Divider, Grid, Typography } from '@mui/material';


// CUSTOM 
import { deepOrange } from '@mui/material/colors';
import { IUserPermissions } from '../../commons/interfaces';
import { mtDividerCardUSer, paddingCardsTables } from '../../commons';
import { AvatarUsuariosPermissions } from '../AvatarUsuariosPermissions';





export const EditCardUserSystemDetails = ( props:IUserPermissions ) => {


  // USE STATE 
  const [employee, setEmployee] = useState<IUserPermissions>({
    id: 'Cargando...',
    name: 'Cargando...',
    email: 'Cargando...',
    avatar: 'Cargando...',
    status: 'Cargando...',
    permissions: []
  });



  // USE EFFECT 
  useEffect(() => { 
    setEmployee(props);
  }, [props]);


 


  return (
    <>
        <Grid size={{ xs: 12 }} sx={{ position: 'sticky', top: '5rem', zIndex: 1000 }}> 
            <Card
                sx={{
                    alignItems: 'center',
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    bgcolor: 'background.paper',
                    marginTop: paddingCardsTables
                }}
                >

                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem', marginTop: '1rem'}}>
                  <AvatarUsuariosPermissions urlImage={employee.avatar} typeImage={'image-employee'} />
                </div>

                <Typography  sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.10rem', marginTop: 4, textTransform: 'capitalize', fontSynthesisWeight: 400 }}> { employee.name } </Typography>

                <Typography  sx={{ textAlign: 'center',  fontSize: '0.9rem',  textTransform: 'lowercase' }}> { employee.email }  </Typography>

                <Typography   sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1rem', marginTop: 4, textTransform: 'capitalize', fontSynthesisWeight: 400 }}> 
                    {
                       employee.status ? <Chip size='small' label="Activo" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700, textAlign: 'center' }} /> : <Chip size='small' label="Inactivo" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700, textAlign: 'center' }} />
                    }
                </Typography>   
                
                <Divider sx={{ marginTop: mtDividerCardUSer }}/>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                    // disabled={isSubmitting}
                    style={{margin:5, justifyContent: 'center'}}
                    type="submit"
                    variant="contained"
                    >
                        Guadar Cambios
                    </Button>
                </div>
            </Card>
        </Grid>
    </>
  )
}
